define('banner/banner',['require','exports','module','lodash','durandal/app','knockout','plugins/router','cookie-handler','./execute-custom-banners'],function (require, exports, module) {
    var _ = require('lodash');
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var cookieHandler = require('cookie-handler');
    var executeCustomBanners = require('./execute-custom-banners');

    function removeFunctions(banner) {
        if (banner) {
            return JSON.parse(JSON.stringify(banner));
        }
        return undefined;
    }

    module.exports = function () {
        var self = this;

        /**
         * Banner implementation using PubSub. Publish a message by including a banner object consisting of options.
         *
         * Banner Options:
         *
         * id:
         * String attached to that banner element's ID attribute. Required for the disableTime feature.
         *
         * classes:
         * String attached to that banner element's class attribute. At least a ToGo alert class required.
         *
         * hideCloseIcon:
         * Boolean that specifies whether a close icon is shown.
         *
         * iconClasses:
         * Specify class attributes for the icon positioned to the left of text content.
         * Usually a citrix icon.
         *
         * titleClasses:
         * Specify class attributes for the title element.
         *
         * title:
         * String translated into HTML.
         *
         * messageClasses:
         * Specify class attributes for the message element.
         *
         * message:
         * String translated into HTML.
         *
         * removeOnNavigation:
         * Boolean that specifies whether to remove the banner on navigation.
         *
         * timeout:
         * Number in milliseconds. The banner will be removed after the time period expires.
         *
         * disableTime:
         * Requires a the id property to be set! Number in milliseconds. If this is provided, adding a
         * matching banner will be blocked until a cookie timer expires.
         *
         * onAddSuccess:
         * A function that will execute when adding a banner succeeds.
         *
         * onAddFailure:
         * A function that will execute when adding a banner is blocked.
         *
         * onRemove:
         * A function that will execute when the banner has been removed.
         *
         * Banner options will also support Knockout Observables, and will update values accordingly.
         *
         * Example:
         *      self.messageObservable = ko.observable('An error has occured');
         *      var printSuccess = function () { console.log('Banner shown.') };
         *
         *      var banner = {
         *          id: 'api-failure',
         *          classes: 'alert-danger',
         *          iconClasses: 'togo-icon togo-icon-check',
         *          title: 'Warning!',
         *          message: messageObservable,
         *          onAddSuccess: printSuccess
         *      }
         *
         *      app.trigger('banner:add', banner)
         *
         *      --> Banner shown.
         *
         *      messageObservable('Error resolved'); // Will update the message currently displayed
         */
        self.banners = ko.observableArray();
        self.reactOptions = ko.observable();

        app.on('banner:add').then(function (banner) {
            // Handles add logic, except for disableTime
            var handleAdd = function () {
                if (banner.isReactComponent) {
                    self.reactOptions = ko.computed(function () {
                        return {
                            component: banner.ReactComponent,
                            props: banner.ReactProps
                        };
                    });
                }

                self.banners.push(banner);

                if (banner.removeOnNavigation) {
                    // Remove the banner if the page navigates
                    router.isNavigating.subscribe(function () {
                        app.trigger('banner:remove', banner);
                    });
                }

                if (banner.timeout) {
                    // Remove the banner after a timeout
                    window.setTimeout(function () {
                        app.trigger('banner:remove', banner);
                    }, banner.timeout);
                }

                // Execute the success callback function.
                // Pass any relevant data to the callback in bannerData.
                var bannerData = {
                    // The added DOM element
                    element: $('.global-banner .alert')[self.banners().length - 1]
                };
                if (banner.onAddSuccess) {
                    banner.onAddSuccess(bannerData);
                }
            };

            /*
             * If there is no disableTime option set, immediately execute the add function.
             * Otherwise, only execute the add function if there is no banner cookie found.
             */
            if (banner.disableTime) {
                if (!cookieHandler.get(banner.id)) {
                    handleAdd();
                } else {
                    if (banner.onAddFailure) {
                        banner.onAddFailure();
                    }
                }
            } else {
                handleAdd();
            }
        });

        app.on('banner:addReact').then(function (banner) {
            self.reactOptions({
                component: banner.ReactComponent,
                props: banner.ReactProps
            });

            if (banner.removeOnNavigation) {
                // Remove the banner if the page navigates
                router.isNavigating.subscribe(function () {
                    var props = Object.assign(banner.ReactProps, {
                        disable: true
                    });

                    self.reactOptions({
                        component: banner.ReactComponent,
                        props: props
                    });
                });
            }
        });

        // Add the banner only if the banner does not yet exist based on a deep object comparison
        // Functions don't work with a deep comparison, so ignore functions before comparing
        app.on('banner:addOne').then(function (banner) {
            if (_.findWhere(self.banners().map(removeFunctions), removeFunctions(banner))) {
                if (banner.onAddFailure) {
                    banner.onAddFailure();
                }
            } else {
                app.trigger('banner:add', banner);
            }
        });

        // Handles disableTime and onRemove callback function.
        var handleRemove = function (banner) {
            // The user has actively removed the banner, so set a timed cookie to block the banner.
            if (banner.disableTime) {
                cookieHandler.setTime(banner.disableTime, banner.id, true);
            }

            if (banner.onRemove) {
                banner.onRemove();
            }
        };

        // Remove all banners that match. Uses a deep equality to compare.
        // Functions don't work with a deep comparison, so ignore functions before comparing
        app.on('banner:remove').then(function (banner) {
            var removedBanners = self.banners.remove(function (listedBanner) {
                return _.isEqual(removeFunctions(listedBanner), removeFunctions(banner));
            });

            if (removedBanners.length > 0) {
                handleRemove(banner);
            }
        });

        app.on('banner:removeAll').then(function () {
            _.forEach(self.banners(), function (banner) {
                app.trigger('banner:remove', banner);
            });
        });

        /*
         * Internal function executed by clicking the X icon.
         * Necessary because clicking the X should only remove that "specific" banner.
         * The normal remove function would remove all matching that banner, which may not be intended.
         */
        self.removeIndex = function (index) {
            var banner = self.banners.splice(index(), 1)[0];
            handleRemove(banner);
        };

        self.activate = function () {
            executeCustomBanners();
        };
    };
});

